module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "index"
  }, [_c('div', {
    staticClass: "centered"
  }, [_c('router-link', {
    staticClass: "button centered",
    attrs: {
      "to": {
        name: 'PartnerEditor',
        params: {
          id: 'new'
        }
      }
    }
  }, [_vm._v("Добавить партнера")])], 1), _vm._v(" "), _c('ul', {
    staticClass: "list column is-8 is-offset-2 columns is-multiline"
  }, _vm._l((_vm.partners), function(partner) {
    return _c('router-link', {
      key: partner.id,
      staticClass: "column is-half",
      attrs: {
        "to": {
          name: 'PartnerEditor',
          params: {
            id: partner.id
          }
        }
      }
    }, [_c('div', {
      staticClass: "box"
    }, [(partner.logo.image) ? _c('img', {
      attrs: {
        "src": "/upload/photos/" + partner.logo.image
      }
    }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('strong', [_vm._v(_vm._s(partner.title))]), _c('br'), _vm._v(" "), _c('span', [_vm._v("Ссылка:")]), _vm._v(" "), _c('a', {
      attrs: {
        "href": partner.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(partner.url))]), _vm._v(" "), _c('button', {
      staticClass: "delete is-pulled-right",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.del(partner.id)
        }
      }
    })])])
  }), 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-eaf977e0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Partners/Index.vue
// module id = 1009
// module chunks = 0